import { shallowMemoize } from '@sail/utils';
export default function memoizeConfig(fn) {
    return shallowMemoize(fn);
}

//# sourceMappingURL=memoizeConfig.js.map